import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, Row, Col, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import Heading from '../common/Heading';
import Loader from '../common/Loader';
import BZAPIService from '../../services/BZAPIService';

const ViewSupportTickets = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [supportTickets, setSupportTickets] = useState([]);

  // const navigate = useNavigate();

  useEffect(() => {
    async function onLoad() {
      console.log('load...');

      try {
        const domain = window.location.hostname.split('.');
        const subdomain = domain.shift();
        console.log('subdomain', subdomain);
        const getSupportTickets = await BZAPIService.viewSupportTickets({
          bz_tenant_id: subdomain + '@findbugzero.com'
        });

        setSupportTickets(getSupportTickets.data);
        setIsLoading(false);
      } catch (e) {
        console.log(e);
        setIsLoading(false);
      }
      // Init defaults
    }
    onLoad();
  }, []);

  return (
    <Fragment>
      <Heading title="Support cases" subtitle="View your support cases" className="mb-4 mt-3" icon="life-ring" />
      <Card bg={'light'} text={'dak'} className="mb-4">
        {isLoading && (
          <>
            <Loader text="Loading tickets..." />
          </>
        )}
        {!isLoading && supportTickets.length > 0 ? (
          <CardBody>
            <Row>
              <Col lg="12">
                <Table hover>
                  <thead className="thead-light">
                    <tr>
                      {supportTickets[0].map(ticket => {
                        return ticket.label !== 'Description' ? <th key={ticket.label}>{ticket.label}</th> : null;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {supportTickets.map(ticket => {
                      let id = ticket[1].value;
                      console.log(ticket[1].value);
                      return (
                        <tr key={id}>
                          {ticket.map(item => {
                            return item.label !== 'Description' ? (
                              <td key={item.value} data-testid={item.label + '-value'}>
                                <Link to={{ pathname: `/support/view-tickets/${id}`, state: ticket }} state={ticket}>
                                  {item.value}
                                </Link>
                              </td>
                            ) : null;
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </CardBody>
        ) : null}
        {!isLoading && supportTickets.length === 0 ? (
          <CardBody>
            <Row>
              <Col lg="12">
                <p>No support tickets found</p>
              </Col>
            </Row>
          </CardBody>
        ) : null}
      </Card>
    </Fragment>
  );
};
export default ViewSupportTickets;
